import { Switch } from 'react-router-dom'

import AuthenticatedRoute from '@/components/AuthenticatedRoute'
import RouteNotFound from '@/components/RouteNotFound'
import { AppRoute } from '@/routes'

export type AppRoutesProps = {
  currentSpaceId?: string
  isAuthenticated?: boolean
  isError?: boolean
  isLoading?: boolean
  isTenantConfigurationLoaded?: boolean
  // may temporarily be null while the context organization is loaded
  organization?: { id: string }
  routes: AppRoute[]
}

function AppRoutes({ currentSpaceId, isAuthenticated, isLoading, organization, routes }: AppRoutesProps) {
  return (
    <Switch>
      {routes.map(route => (
        // @ts-expect-error
        <AuthenticatedRoute
          key={route.path}
          {...route}
          currentSpaceId={currentSpaceId}
          isAuthenticated={isAuthenticated}
          isContextLoading={isLoading}
          organizationId={organization ? organization.id : null}
        />
      ))}
      <RouteNotFound />
    </Switch>
  )
}

export default AppRoutes
